import { render, staticRenderFns } from "./ReferencesView.vue?vue&type=template&id=4dd397cd&"
import script from "./ReferencesView.vue?vue&type=script&lang=js&"
export * from "./ReferencesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports